// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activateWarningContent___MEJ-Y{padding:24px 0;line-height:24px}.merchantInfo___\\+TVI6{padding-bottom:24px}.modalContainer___Y\\+ySF{width:464px}\n", "",{"version":3,"sources":["webpack://./src/routes/Overrides/components/ActivateMerchantModal/ActivateMerchantModal.css"],"names":[],"mappings":"AAAA,gCAAA,cAAA,CAEI,gBAAA,CAGJ,uBACI,mBAAA,CAGJ,yBACI,WAAA","sourcesContent":[".activateWarningContent {\n    padding: 24px 0;\n    line-height: 24px;\n}\n\n.merchantInfo {\n    padding-bottom: 24px;\n}\n\n.modalContainer {\n    width: 464px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activateWarningContent": "activateWarningContent___MEJ-Y",
	"merchantInfo": "merchantInfo___+TVI6",
	"modalContainer": "modalContainer___Y+ySF"
};
export default ___CSS_LOADER_EXPORT___;
